import Vue from 'vue';
import VueRouter from 'vue-router';
import mainMenu from '@/views/mainMenu.vue';
import employees from '@/views/employees.vue';
import semminary from '@/views/semminary.vue';
import geneaology from '@/views/geneaology.vue';
import students from '@/views/students.vue';
import books from '@/views/books.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'mainMenu',
    component: mainMenu,
  },
  {
    path: '/pracownicy',
    name: 'employees',
    component: employees,
  },
  {
    path: '/seminaria',
    name: 'semminay',
    component: semminary,
  },
  {
    path: '/geneaologia',
    name: 'geneaology',
    component: geneaology,
  },
  {
    path: '/studenci',
    name: 'students',
    component: students,
  },
  {
    path: '/ksiazki',
    name: 'books',
    component: books,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
